// extracted by mini-css-extract-plugin
export default {"discount":"DiscountBadge-EzFgx__discount","discountIcon":"DiscountBadge-34yXT__discountIcon"};